import { Button } from "../ui/button";

/** Keep the last snapshot visible and offer the same recovery on both pages. */
export function ConnectionsLoadError({
  hasSnapshot,
  isRefreshing,
  onRetry,
}: {
  readonly hasSnapshot: boolean;
  readonly isRefreshing: boolean;
  readonly onRetry: () => void;
}) {
  return (
    <div
      role="alert"
      className="flex flex-wrap items-center justify-between gap-3 rounded-lg border border-destructive/40 bg-destructive/5 px-4 py-3 text-sm text-destructive"
    >
      <span>
        {hasSnapshot
          ? "Account status could not be refreshed."
          : "Connections could not be loaded."}
      </span>
      <Button
        size="sm"
        variant="outline"
        disabled={isRefreshing}
        aria-busy={isRefreshing}
        onClick={onRetry}
      >
        Try again
      </Button>
    </div>
  );
}
